// Native Stretch dialogs still own their open state, focus trap and animation.
// Close the current menu or drawer before following an in-page content link.
document.addEventListener('click', async (event) => {
  const link = event.target.closest('a[data-bfc-menu-anchor]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
  const target = document.getElementById(destination.hash.slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  const dialog = link.closest('header-mega-menu, header-menu-drawer, cart-drawer, x-drawer');
  if (dialog?.hasAttribute('open') && typeof dialog.hide === 'function') {
    dialog.focusTrap?.deactivate({returnFocus: false, onDeactivate: () => {}});
    await dialog.hide();
  }
  // Keep Shopify preview parameters intact.
  history.pushState(null, '', destination.hash);
  target.tabIndex = -1;
  target.focus({preventScroll: true});
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
}, true);

// Stretch owns panel animation. Hand focus over only after the old panel is hidden.
const bfcObserveDrawerNavigation = (drawer) => {
  if (drawer.dataset.bfcNavigationReady) return;
  drawer.dataset.bfcNavigationReady = 'true';
  let pendingSwitch = null;
  let returnFocusTarget = null;

  drawer.addEventListener('dialog:before-show', () => {
    const focused = document.activeElement;
    returnFocusTarget = focused?.getAttribute('aria-controls') === drawer.id
      ? focused
      : drawer.controls.find((control) => control.getClientRects().length && !control.disabled);
  });

  drawer.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !drawer.hasAttribute('open') || typeof drawer.hide !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    drawer.hide();
  }, true);

  drawer.addEventListener('dialog:after-hide', () => {
    pendingSwitch = null;
    if (returnFocusTarget?.isConnected && !returnFocusTarget.disabled && returnFocusTarget.getClientRects().length) {
      returnFocusTarget.focus({ preventScroll: true });
    }
    returnFocusTarget = null;
  });

  drawer.addEventListener('click', (event) => {
    const toggle = event.target.closest('button[data-panel-toggle]');
    if (!toggle || pendingSwitch) return;
    const panel = toggle.closest('header-menu-drawer-panel');
    if (!panel?.classList.contains('is-visible')) return;
    pendingSwitch = { from: panel.id, to: toggle.getAttribute('aria-controls') };
  }, true);

  const updatePanel = () => {
    const visiblePanels = [...drawer.querySelectorAll('header-menu-drawer-panel.is-visible')];
    if (visiblePanels.length !== 1) return;
    const panel = visiblePanels[0];
    const mainPanel = drawer.querySelector('[data-main-panel]');
    if (!mainPanel) return;
    mainPanel.querySelectorAll('button[data-panel-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-controls') === panel.id));
    });
    if (!pendingSwitch || pendingSwitch.to !== panel.id) return;
    const previousPanelId = pendingSwitch.from;
    pendingSwitch = null;
    if (!drawer.hasAttribute('open')) return;
    const focusTarget = panel === mainPanel
      ? [...mainPanel.querySelectorAll('button[data-panel-toggle]')].find((toggle) => toggle.getAttribute('aria-controls') === previousPanelId)
      : panel.querySelector('button[data-panel-toggle]');
    focusTarget?.focus({ preventScroll: true });
  };

  const panelObserver = new MutationObserver(updatePanel);
  drawer.querySelectorAll('header-menu-drawer-panel').forEach((panel) => {
    panelObserver.observe(panel, { attributes: true, attributeFilter: ['class'] });
  });
  updatePanel();
};

const bfcInitDrawerNavigation = (scope = document) => {
  scope.querySelectorAll('header-menu-drawer').forEach(bfcObserveDrawerNavigation);
};
bfcInitDrawerNavigation();
document.addEventListener('shopify:section:load', (event) => bfcInitDrawerNavigation(event.target));

document.addEventListener('submit', (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.matches('form[data-bfc-catalog-form]')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
}, true);
